// extracted by mini-css-extract-plugin
export var active = "_f6-7";
export var blink = "_f6-8";
export var dropDownSelector = "_f6-4";
export var dropDownWrapper = "_f6-3";
export var fakeCursor = "_f6-6";
export var fontSizeButton = "_f6-9";
export var formQuillEditor = "_f6-0";
export var pressed = "_f6-a";
export var qlBlank = "_f6-1";
export var textFormattingToolbar = "_f6-2";
export var textToolbarOption = "_f6-5";